import Vue from 'vue'
import Router from 'vue-router'
import axios from './services/vue-axios/axios.js'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/views/home'),
    },
    {
      path: '/ethernet',
      name: 'EthernetQuotes',
      component: () => import('@/views/ethernet/index'),
    },
    {
      path: '/ethernet/results',
      name: 'EthernetResults',
      component: () => import('@/views/ethernet/results'),
    },
    {
      path: '/about-us',
      name: 'About Us',
      component: () => import('@/views/about-us'),
    },
    {
      path: '/support',
      name: 'Customer Support',
      component: () => import('@/views/support'),
    },
    {
      path: '/partners',
      name: 'Partners',
      component: () => import('@/views/partners'),
    },
  ],
})

export default router
